import _window from "@src/libraries/window";
import axios from "@src/libraries/axios";
import Vue from "@src/libraries/vue";
import analytics from "@src/store/analytics";
import { moduleDebug } from "@src/assets/js/debug";
import { API_V2_URL, visibilityUpdate, windowLoad } from "@src/assets/js/utils";
import { silentReport } from "@src/assets/js/report";
import http from "@src/assets/js/requests/http";
import request from "@src/assets/js/requests/request";
import localesStore from "@src/store/locales";
import usersStore from "@src/store/users";
const MONTH = 2678400;
const paymentsStore = new Vue({
    name: "PaymentStore",
    data() {
        const data = {
            forceSubscribed: false,
            lazySubscribed: undefined,
            payDialog: {
                model: false
            },
            ignoreSubscription: false
        };
        return data;
    },
    computed: {
        payDialogModel() {
            return this.payDialog.model;
        },
        subscribed() {
            const payment = this.payment;
            const forceSubscribed = this.forceSubscribed;
            const ignoreSubscription = this.ignoreSubscription;
            if (ignoreSubscription)
                return true;
            const subscribed = !!payment || forceSubscribed;
            if (!payment && !subscribed)
                return payment;
            if (this.lazySubscribed != subscribed)
                this.lazySubscribed = subscribed;
            return subscribed;
        },
        isChile() {
            const country = localesStore.country;
            if (!country)
                return;
            return "CL" == country.toUpperCase();
        },
        currency() {
            const isChile = this.isChile;
            if ("undefined" == typeof isChile)
                return;
            if (isChile)
                return "CLP";
            return "USD";
        },
        subscriptions() {
            const allSubscriptions = this.allSubscriptions;
            return allSubscriptions || [];
        },
    },
    asyncComputed: {
        allSubscriptions: {
            lazy: true,
            async get() {
                const lang = localesStore.lang;
                const currency = this.currency;
                if (!lang)
                    return;
                let req = API_V2_URL + "/subscriptions?lang=" + lang;
                if (currency)
                    req += "&currency=" + currency;
                return request.pub(req, "Array");
            }
        },
        payment: {
            lazy: true,
            async get() {
                const me = usersStore.me;
                if (!me)
                    return me;
                const payment = await this.paymentUser(me.id);
                return payment || false;
            }
        },
    },
    watch: {
        payDialogModel: {
            immediate: true,
            handler(payDialogModel) {
                if (payDialogModel) {
                    this.reset();
                    analytics.page("pay");
                }
            },
        },
        payment(payment, prevPayment) {
            analytics.identify({ payment });
        }
    },
    created() {
        const self = this;
        visibilityUpdate(function (visible) {
            const subscribed = self.subscribed;
            if (visible && !subscribed) {
                try {
                    self.reset();
                }
                catch (e) {
                    silentReport(e);
                }
            }
        });
        const location = _window.location;
        if (location && location.href.includes("paydialog")) {
            this.showPayDialog();
        }
    },
    methods: {
        async showPayDialog() {
            await windowLoad();
            this.payDialog.model = true;
        },
        hidePayDialog() {
            this.payDialog.model = false;
        },
        async reset() {
            const me = usersStore.me;
            const paymentUser = this.paymentUser;
            if (!me || !me.id)
                return;
            const payment = await paymentUser(me.id);
            console.log("reset payment", payment);
            this.payment = payment;
            return payment;
        },
        async paymentUser(userId) {
            const req = API_V2_URL + "/payments/current";
            return await http.get(req, "Object", {
                "cache-control": "max-age=0, no-cache, no-store, private"
            });
        },
        isSubscribed(payment) {
            if (!payment)
                return;
            const now = new Date().getTime() / 1000;
            if (payment.subscription_end && payment.subscription_end > now) {
                return payment.subscription_end > now;
            }
            const paid = Math.max(payment.paid || 0, payment.sent || 0);
            if (paid)
                return (paid + MONTH) > now;
            return false;
        },
        async subscribedUserId(userId) {
            const payment = await this.paymentUser(userId);
            return this.isSubscribed(payment);
        },
        async checkSubscription() {
            const admin = usersStore.admin;
            const me = usersStore.me;
            const subscribedUserId = this.subscribedUserId;
            const showPayDialog = this.showPayDialog;
            const subscribed = this.subscribed;
            if (subscribed || admin)
                return true;
            if (!me) {
                if (false === me)
                    usersStore.login();
                return false;
            }
            const meSubscribed = await subscribedUserId(me.id);
            if (!meSubscribed)
                showPayDialog();
            return !!meSubscribed;
        },
        async createAndUpdate(data) {
            console.log("createAndUpdate");
            const updatePaymentResponse = await axios.post(API_V2_URL + "/payments", data);
            const updatePayment = updatePaymentResponse.data;
            if (updatePayment) {
                this.payment = updatePayment;
            }
        },
        paid() {
            if (!this.payment && !this.forceSubscribed)
                this.forceSubscribed = true;
        }
    }
});
export default paymentsStore;
moduleDebug(paymentsStore);
